import * as React from 'react';
import {withParams } from '@@/components/General/Navigate';
import { Column, Row } from '@selkirk-systems/layout';
import SummaryTable from '@@/components/Landing/SummaryTable';
import StatusList from '@@/components/Landing/StatusList';

import Typography from '@@/components/General/Typography';
import ActiveFiresByStatusGraph from '@@/components/Landing/ActiveFiresByStatusGraph';
import Paper from '@@/components/General/Paper';

import { fetchIncidentData } from '@@/actions/IncidentActions';
import UpdatedText from '@@/components/Landing/UpdatedText';

import '@@/css/landing.css';

class LandingApp extends React.Component {

    static defaultProps = {
        params:{}
    }

    componentDidMount() {
        fetchIncidentData();
    }

    render() {

        const {params} = this.props;

        return (
            <Column gap='md' xs="auto auto 1fr">
                {params.withHeader && <Typography variant="h1">Active Incidents</Typography>}
                <Paper elevation={3}>
                    <Row justify='left' gap='sm' p='lg'>
                        <Typography variant="h5">Updated:</Typography>
                        <Typography style={{fontWeight:300}} variant='h5'><UpdatedText/></Typography>
                    </Row>
                    <div pl='lg' pr='lg'>
                        <hr/>
                    </div>
                    <SummaryTable mt='md' mb='md'/>
                </Paper>
                <Paper elevation={3} p='lg' className='relative'>
                    <Typography variant="h4" mb='xl'>Current Active Wildfires</Typography>
                    <hr/>
                    <Row xs="1fr" sm="300px 1fr" gap='lg' pt='lg' pb='lg' >
                        <StatusList />
                        <ActiveFiresByStatusGraph/>
                    </Row>
                </Paper>
            </Column>
        );
    }
}


export default withParams(LandingApp);
